/**
 * Created on 2017/2/19.
 */
define('controllers/myaccount/earnings/account-earnings.ctrl',['app', 'mainCons'], function (app, mainCons) {
    app.controller('AccountEarningsCtrl', ['$q', '$scope', '$state', '$filter', '$http', 'auiDialog', 'OpenTrade', 'OpenApp', 'tenantsService', 'ExportExcel',
        function ($q, $scope, $state, $filter, $http, auiDialog, OpenTrade, OpenApp, tenantsService, ExportExcel) {
            //6.0.6历史结算单只给查询和下载，去掉其他功能，包括去掉查看明细(支付明细),去掉支付明细下载，去掉申请结算和单个的收益的申请结算
            var settleReturnDesc = mainCons.reportAll.settleReturnDesc;
            //采用Model构建数据
            var Model = $scope.Model = {
                constant: mainCons.earningsConstant,
                bills: [],
                query: {
                    maxDate: new Date(getLatestMonth() + '-01'),
                    billTime: new Date(getLatestMonth() + '-01'),
                    minDate: new Date(get3yearAgo() + '-01'),
                    serviceType: {
                        selected: {val: '9211132', title: '游戏'},
                        ServiceTypeList: mainCons.earningsConstant.serviceType2
                    },
                    status: {
                        selected: {val: '-1', title: '全部'},
                        statusList: [{
                            val: '-1',
                            title: '全部'
                        }].concat(mainCons.earningsConstant.billStatus2)
                    }
                },
                pagination: {
                    currentPage: 1,// 当前页
                    itemsPerPage: 100,// 默认每页个数
                    totalCount: 0,
                    noItems: "No products",
                    pagesLength: 5,// 显示的页码数量,
                    perPageOptions: [100],
                    onChange: queryBillList
                }
            };
            $scope.downloadExcel = downloadExcel;


            //页面初始化加载项
            function initPage() {
                $scope.$watch(function () {
                    return JSON.stringify(Model.query);
                }, function () {
                    checkBussness().then(function () {
                        queryBillList();
                    });
                });
            }

            function checkBussness() {
                var defer = $q.defer();
                // cp如果没有签订商户服务就访问收益菜单要引导cp开通商户服务,签协议改到商户界面签,去掉变量window.earningsFlag，没什么用
                tenantsService.isBankVoid().then(function (isMerchant) {
                    if (!isMerchant) {
                        auiDialog.warn('您的商户服务还未开通或者还处于审核中，如果有疑问请联系客服。', function () {
                            $state.go('mysetting.modBussnessInfo', {}, {reload: true});
                        });
                        defer.reject();
                    } else {
                        defer.resolve(true);
                    }
                });
                return defer.promise;
            }

            function queryBillList() {
                //status、projectNo、memberUserID 不传入
                var params = {
                    "startTime": getyyyymm(Model.query.billTime),
                    "endTime": getyyyymm(Model.query.billTime),
                    "pageNo": Model.pagination.currentPage + '',
                    "pageSize": Model.pagination.itemsPerPage + '',
                    "dateType": "M",
                    "projectNo": Model.query.serviceType.selected.val
                };

                params.startTime = params.startTime + '';
                params.endTime = params.endTime + '';

                if (Model.query.status.selected.val != -1) {
                    params.status = Model.query.status.selected.val;
                }

                queryBillListByParam(params);
            }

            function queryBillListByParam(params) {
                Model.billList = null;
                var defer = $q.defer();
                //参数
                var req = {req: params};
                //调用Trade查询历史结算单
                OpenTrade.getHistorySettlement(req).then(function (resp) {
                    //接口resp.returnCode == 0 才能进入这里
                    resp = typeof resp == 'string' ? JSON.parse(resp) : resp;
                    if (resp.data) {
                        Model.billList = resp.data;
                        var prodIDs = [];
                        Model.billList.forEach(function (bill) {
                            bill.prodName = bill.applicationID;
                            bill.applicationIDTemp = AUI.BaseJSUtil.toLegalProdID(bill.applicationID);
                            prodIDs.push(bill.applicationIDTemp);
                        });
                        prodIDs = AUI.BaseJSUtil.unique(prodIDs);
                        if (prodIDs.length != 0) {
                            OpenApp.getProductByID({
                                request: {
                                    prodID: prodIDs
                                }
                            }).then(function (resp) {
                                if (resp.productList.length > 0) {
                                    Model.billList.forEach(function (bill) {
                                        resp.productList.forEach(
                                            function (product) {
                                                if (bill.applicationIDTemp == product.prodID) {
                                                    bill.prodName = product.prodName
                                                }
                                            }
                                        );
                                    });
                                }
                            });
                        }
                    }
                    else {
                        Model.billList = [];
                    }
                    Model.pagination.totalCount = resp.count;
                    Model.totalPayoff = resp.totalPayoff;
                    Model.notPayoff = resp.notPayoff;
                    defer.resolve(resp);
                    //TODO
                    Model.bills = [];
                    defer.resolve();
                });
                return defer.promise;
            }

            function getLatestMonth() {
                var today = new Date();
                var year = today.getFullYear();
                var month = today.getMonth();
                if (month == 0) {
                    return (year - 1 + '-' + '12');
                }
                return (year + '-' + (month > 9 ? '' : '0') + month);
            }

            function getyyyymm(date) {
                if (typeof date == 'string') {
                    return date.replace('-', '');
                }
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                return year + (month > 9 ? '' : '0') + month;
            }


            //获取3年前
            function get3yearAgo() {
                var today = new Date();
                var year = today.getFullYear();
                year = year - 3;
                var month = today.getMonth();
                return (year + '-' + (month > 9 ? '' : '0') + month);
            }

            function downloadExcel(){
                if(!Model.billList || Model.billList.length <= 0){
                    return;
                }
                var defer = $q.defer();
                ExportExcel.table2Excel('downloadExcelId','结算单.xlsx','结算单');
                defer.resolve();
                return defer.promise;
            }

            //加载页面
            initPage();

        }]);
});

